import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { Card } from '../../../components/article/Card';
import { PathsLayouts } from '../../../config/routes';

function toPercentage(value: number) {
  return `${value.toFixed(1)}%`;
}

export interface TuitionContinuityProcessManagementItemProps {
  periodId: number | string;
  studyPlanVersionOfferId: number;
  studyPlanVersionName: string;
  campusName: string;
  scheduleName: string;
  total: number;
  completed: number;
  started: number;
  notStarted: number;
}

export default function TuitionContinuityProcessManagementItem(
  props: TuitionContinuityProcessManagementItemProps,
) {
  const { t } = useTranslation();
  const prefix = 'tuitionContinuityProcessManagement.item';

  const texts = useMemo(
    () => ({
      total: t(`${prefix}.total`),
      completed: t(`${prefix}.completed`),
      started: t(`${prefix}.started`),
      notStarted: t(`${prefix}.notStarted`),
      enrolled: t(`${prefix}.enrolled`),
    }),
    [t],
  );

  return (
    <Card
      title={props.studyPlanVersionName}
      subtitle={`${props.campusName} - ${props.scheduleName}`}
      body={[
        {
          label: texts.total,
          value: props.total,
        },
        {
          label: texts.completed,
          value: props.completed,
        },
        {
          label: texts.started,
          value: props.started,
        },
        {
          label: texts.notStarted,
          value: props.notStarted,
        },
      ]}
      markedText={{
        label: texts.enrolled,
        value: props.total
          ? toPercentage((props.completed * 100) / props.total)
          : '-',
      }}
      to={`${PathsLayouts.tuitionContinuityProcessManagement}/${props.studyPlanVersionOfferId}/period/${props.periodId}`}
    />
  );
}
